<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/HUD/HUD.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">SR-HUD & P-HUD显示系统</div>
                <div class="detail-banner-desc">
                    随着汽车座舱向智能化、场景化升级，车载显示系统正从单一功能转向多维度交互。将传统 HUD 与 P-HUD（全景 HUD）集成，可深度融合 “驾驶信息可视化” 与 “座舱沉浸感营造”，重新定义人车交互视觉边界；<br />
                    SR-HUD 将车速、导航指引、ADAS 预警等关键车辆信息，以虚像投射到前挡风玻璃；P-HUD 则把车辆状态、详细导航地图、多媒体控制界面等场景化辅助信息，直接投射到前挡风玻璃下方黑色区域。二者形成“核心信息悬浮 + 扩展信息全景” 的互补结构，既提升驾驶引导直观性，又共同营造沉浸放松的座舱氛围，带来安全舒适的驾乘体验；<br />
                    SR-HUD 全自研自制：显示模块软硬件均为平台化设计，体积 8 升，工作噪音低于 45 分贝，视场角达
                    9°×3°，且能自动调节亮度，复杂天气下也能保障良好驾驶体验；产品由蜂巢自研主机系统驱动，可通过主机在中控屏直接调整图像高度、亮度与角度，满足不同驾驶者偏好；<br />
                    P-HUD 采用 11.98 英寸 mini-LED 面板：虚像亮度超 1200 尼特，对比度超 10000:1，色域超82%；采用低反光设计，且支持佩戴太阳镜观看，即便强光环境下也能清晰显示，为驾乘人员带来出色沉浸感。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明：SR-HUD</div>
                    <div class="detail-desc">
                        <div>
                            分辨率光高，图像清晰<br />
                        </div>
                        <div>
                            有效减少60%光线反射能量<br />
                        </div>
                        <div>
                            自动亮度调节适用于复杂的天气场景<br />
                        </div>
                        <div>
                            工作噪音小于45DB
                        </div>
                    </div>
                </div>

                <div class="detail-text-box">
                    <div class="detail-title">产品说明：P-HUD</div>
                    <div class="detail-desc">
                        <div>
                            高亮度、高对比度<br />
                        </div>
                        <div>
                            超低反射<br />
                        </div>
                        <div>
                            336分区控光<br />
                        </div>
                        <div>
                            支持偏光太阳眼镜
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/HUD/HUD-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数：SR-HUD
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">1440 x 480</div>
                                    <div class="k">分辨率</div>
                                </div>

                                <div class="spec-item">
                                    <div class="v">9° x 3°</div>
                                    <div class="k">视场角</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">4.5m</div>
                                    <div class="k">投影距离</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≥13,000nits</div>
                                    <div class="k">成像亮度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1200：1</div>
                                    <div class="k">对比度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Unsupported</div>
                                    <div class="k">偏光太阳镜</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">5.1 inch TFT-LCD</div>
                                    <div class="k">技术</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">

                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数：P-HUD
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">1500 x 256</div>
                                    <div class="k">分辨率</div>
                                </div>

                                <div class="spec-item">
                                    <div class="v">54° x 2.0°</div>
                                    <div class="k">视场角</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1.15m</div>
                                    <div class="k">投影距离</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≥1200nits</div>
                                    <div class="k">成像亮度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">＞10000：1</div>
                                    <div class="k">对比度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Support</div>
                                    <div class="k">偏光太阳镜</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">11.98 inch TFT-LCD</div>
                                    <div class="k">技术</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/HUD/HUD-2.jpg" alt="200-1-02">
                    </div>
                </div>



            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'SR-HUD & P-HUD显示系统 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/HUD.html'
};

import { createApp } from 'vue';
import App from './HUD.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./HUD.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
